import { ActiveRecord, sources } from '@mysidewalk/active-record';
/**
 * @memberof system-metadata
 * @property {number} id
 * @property {string[]} authorOrganizations
 * @property {string[]} dataTableTitles
 * @property {string[]} sourceLinks
 * @property {string[]} sourceNames
 * @property {string[]} timeLongNames
 * @property {string[]} timeShortNames
 * @property {Date[]} publishedDates
 * @property {string[]} sourceTables
 * @property {string[]} universes
 * @property {string} description
 * @property {string} calculationMethodology
 * @property {boolean} supportsCustomGeographies
 * @property {number[]} featureClasses
 */
class DimensionDynamicAttribution extends ActiveRecord {
    initialize(props) {
        super.initialize(props);
        this.publishedDates = [...Array.from(new Set(this.publishedDates || []))]
            .map((pd) => new Date(pd))
            .sort((a, b) => a.valueOf() - b.valueOf());
    }
}
DimensionDynamicAttribution.$AR = {
    url: '',
    SourceClass: sources.ActiveRecordJSONAPISource,
};
export default DimensionDynamicAttribution;
